// src/components/Footer.jsx
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Footer = () => {
  return (
    <>
      <div id="call-to-action-container" className="container-fluid">
        <div className="container">
          <div>
            <div>
              <h2>You don't have to struggle alone.</h2>
            </div>
            <div>
              <div>
                <div>
                  <div>
                    <div>
                      <a href="/contact">
                        <LazyLoadImage src="/img/icon-location.svg" alt="Location" effect="blur" />
                      </a>
                    </div>
                  </div>
                  <div>
                    <a href="/contact" style={{ textDecoration: 'none' }}>
                      <p>Find a Redemption Psychiatry Location Near You</p>
                    </a>
                  </div>
                </div>
                <div>
                  <div>
                    <div>
                      <a href="tel:+14804718560">
                        <LazyLoadImage src="/img/icon-phone.svg" alt="Phone" effect="blur" />
                      </a>
                    </div>
                  </div>
                  <div>
                    <a href="tel:+14804718560" style={{ textDecoration: 'none' }}>
                    <p>Call Us – Help is Just One Step Away</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="footer-container" className="container-fluid">
        <div id="top-footer-container" className="container">
          <div>
            <div>
              <div>
                <img src="/img/icon.svg" alt="Logo Icon" />
              </div>
              <div>
                <p>3489 E Baseline Road<br />Gilbert, AZ 85234</p>
                <p>Main: <a href="tel:+14804718560">480.471.8560</a><br />Fax: 888.979.8197</p>
                <div id="footer-social-container">
                  <a href="https://www.facebook.com/redemptionpsychiatry" target="_blank" rel="noopener noreferrer">
                    <LazyLoadImage src="/img/icon-facebook.svg" alt="Facebook" effect="blur" />
                  </a>
                  <a href="https://www.instagram.com/redemptionpsychiatry" target="_blank" rel="noopener noreferrer">
                    <LazyLoadImage src="/img/icon-instagram.svg" alt="Instagram" effect="blur" />
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div>
                <div>
                  <p>Our Services</p>
                  <a href="/med-management">Medication Management</a>
                  <a href="/tms">TMS Therapy</a>
                  <a href="/ketamine">Ketamine Therapy</a>
                  <a href="/adhd-testing">ADHD Testing</a>
                </div>
                <div>
                  <p>Resources & Learning</p>
                  <a href="/resources">Patient Resources</a>
                </div>
                <div>
                  <p>About Us</p>
                  <a href="/about">Our Story</a>
                  <a href="/about">Our Team</a>
                  <a href="/about">Our Partners</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="bottom-footer-container" className="container">
          <div>
            <div>
              <p>© 2025 All Rights Reserved. <a href="/privacy-policy">Privacy Policy</a> | <a href="https://recruiting.paylocity.com/recruiting/jobs/All/954f045d-735f-4e04-8ec7-216c4991e050/Redemption-Psychiatry">Careers</a></p>
            </div>
            <div>
              <p>Website made by Nicholas Farrell</p>
              <p>Content crafted by Garrett Smith</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;